export const FETCHINGSUGGESTIONS = 'fetchingsuggestions';
export const SMART_SEARCH_CARRIER_CODE_FLIGHT_NUMBER_REGEX = /^([a-zA-Z*]{2,3}|[a-zA-Z*]\d|\d[a-zA-Z*])\s*([0-9](?:\d{0,3}))$/;
export const SMART_SEARCH_FLIGHT_NUMBER_REGEX = /([0-9](?:\d{0,3}))/;



// WEBPACK FOOTER //
// ./src/constants/auto-suggest-constants.js